import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 91 90",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 91 90\" id=\"facebook\">\n  <path fill=\"currentColor\" d=\"m63.15 49.016 2.103-13.846H52.1v-8.98c0-3.79 1.834-7.484 7.725-7.484h5.984V6.918s-5.428-.935-10.615-.935c-10.838 0-17.915 6.632-17.915 18.635V35.17H25.237v13.846H37.28v33.472c2.418.384 4.891.58 7.41.58 2.52 0 4.993-.196 7.41-.58V49.016h11.052Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol